import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.859 16.042h7.083c.92 0 1.667-.747 1.667-1.667V7.5l-3.542-3.542H6.859c-.92 0-1.667.747-1.667 1.667v8.75c0 .92.746 1.667 1.667 1.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M15.4 7.708h-3.54V4.167m-3.335 8.541h3.75m-3.75-2.5h3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);